<mat-form-field fxFlex class="field-full-width">
    <mat-label>Assurance</mat-label>
    <input matInput [value]="insuDescription" mat-autoresize="true" placeholder="Assurance">
</mat-form-field>
